module.exports = __webpack_public_path__ + "static/media/spritual2.b897b6d0.webp";